import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';
import 'payment-calculator/components/PaymentCalculatorDetails/components/FinanceMethodPage/FinanceMethodPage.scss';

import { PurchaseMethods, Vehicle } from '@sm360/widget-commons-vehicle';

import CustomizePayment from 'payment-calculator/components/PaymentCalculatorDetails/components/CustomizePayment/CustomizePayment.jsx';
import CalculatorCashdown from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorCashdown/CalculatorCashdown.jsx';
import CalculatorTerms from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTerms/CalculatorTerms.jsx';
import CalculatorTradein from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTradein/CalculatorTradein.jsx';
import Distance from 'payment-calculator/components/Distance/Distance.jsx';
import CalculatorRebateStandardRate from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorRebateStandardRate/CalculatorRebateStandardRate.jsx';
import ResidualValue from 'payment-calculator/components/ResidualValue/ResidualValue.jsx';

const FinanceMethodPage = ({ purchaseMethods, tradeInVehicle, actions }) => {
    let kmPlanBlock;

    if (purchaseMethods.lease.selected) {
        kmPlanBlock = (
            <div>
                <Distance purchaseMethods={purchaseMethods} onKMPlanClick={actions.setKMPlan} />
                <ResidualValue residualValue={purchaseMethods.getSelectedPurchaseMethodResidualAmounts()} />
            </div>
        );
    }

    const { tradeIn, lien } = purchaseMethods;

    return (
        <div className="calculatorRow">
            <div className="calculatorColumn">
                <CustomizePayment
                    purchaseMethods={purchaseMethods}
                    updateTargetPayment={actions.updateTargetPayment}
                    selectPaymentFrequency={actions.selectPaymentFrequency}
                    setCashDown={actions.setCashDown}
                />
                <CalculatorCashdown setCashDown={actions.setCashDown} purchaseMethods={purchaseMethods} />
                {kmPlanBlock}
            </div>
            <div className="calculatorColumn">
                <CalculatorTerms purchaseMethods={purchaseMethods} />
            </div>
            <div className="calculatorColumn">
                <CalculatorTradein
                    tradeInVehicle={tradeInVehicle}
                    tradeIn={tradeIn}
                    lien={lien}
                    setTradeIn={actions.setTradeIn}
                    setLien={actions.setLien}
                />
                <CalculatorRebateStandardRate stdRebate={purchaseMethods.getSelectedRebatesAtStandardRate()} />
            </div>
        </div>
    );
};

FinanceMethodPage.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel),
    actions: PropTypes.shape({
        updateTargetPayment: PropTypes.func.isRequired,
        selectPaymentFrequency: PropTypes.func.isRequired,
        setCashDown: PropTypes.func.isRequired,
        setTradeIn: PropTypes.func.isRequired,
        setLien: PropTypes.func.isRequired,
        setKMPlan: PropTypes.func.isRequired,
    }),
};

FinanceMethodPage.defaultProps = {
    actions: [],
};

FinanceMethodPage.displayName = 'FinanceMethodPage';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
        tradeInVehicle: state.tradeInVehicle,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinanceMethodPage);



// WEBPACK FOOTER //
// ./src/components/PaymentCalculatorDetails/components/FinanceMethodPage/FinanceMethodPage.jsx